import { createAction } from 'redux-actions';
import * as types from './types';

export const setCommunityTheme = createAction(types.SET_THEME);
